import { createFileRoute } from "@tanstack/react-router"
import { lazy } from "react"
import LazyRoutePage from "../../../-LazyRoutePage"

const AutoReplenishmentPoliciesPage = lazy(
  () =>
    import(
      "../../../../components/WMS/AutoReplenishment/AutoReplenishmentPoliciesPage.tsx"
    ),
)

export const Route = createFileRoute(
  "/_layout/WMS/auto-replenishment/policies",
)({
  component: AutoReplenishmentPoliciesRoute,
})

function AutoReplenishmentPoliciesRoute() {
  return (
    <LazyRoutePage>
      <AutoReplenishmentPoliciesPage />
    </LazyRoutePage>
  )
}
